import { render } from "./journalsindex.vue?vue&type=template&id=b54f78e8&scoped=true"
import script from "./journalsindex.vue?vue&type=script&lang=js"
export * from "./journalsindex.vue?vue&type=script&lang=js"

import "./journalsindex.vue?vue&type=style&index=0&id=b54f78e8&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54f78e8"]])

export default __exports__